var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCam2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.6 453.4h-71.5c-6.7 0-12.1-5.4-12.1-12.1V179c0-6.7 5.4-12.1 12.1-12.1h71.5c6.7 0 12.1 5.4 12.1 12.1v262.3c-0.1 6.7-5.5 12.1-12.1 12.1z",
    fill: "#9BCFDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.3 467.7h-68.9c-15.3 0-27.7-12.4-27.7-27.7V180.3c0-15.3 12.4-27.7 27.7-27.7h68.9c15.3 0 27.7 12.4 27.7 27.7V440c0 15.3-12.4 27.7-27.7 27.7zM140.4 439h66.8V181.4h-66.8V439z",
    fill: "#154B8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8 787.1V285.8c0-12.8 10.3-23.1 23.1-23.1H921c12.8 0 23.1 10.3 23.1 23.1v501.3c0 12.8-10.3 23.1-23.1 23.1H69.9c-12.8 0-23.1-10.3-23.1-23.1z",
    fill: "#FCFCFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M918.6 824.6H72.4c-22 0-39.9-17.9-39.9-39.9V288.3c0-22 17.9-39.9 39.9-39.9h846.2c22 0 39.9 17.9 39.9 39.9v496.4c0 22-17.9 39.9-39.9 39.9zM72.4 277.1c-6.2 0-11.2 5-11.2 11.2v496.4c0 6.2 5 11.2 11.2 11.2h846.2c6.2 0 11.2-5 11.2-11.2V288.3c0-6.2-5-11.2-11.2-11.2H72.4z",
    fill: "#10457E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M655.7 536.5m-320.2 0a320.2 320.2 0 1 0 640.4 0 320.2 320.2 0 1 0-640.4 0Z",
    fill: "#FAFCFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M655.7 871c-89.4 0-173.4-34.8-236.6-98-63.2-63.2-98-147.2-98-236.6s34.8-173.4 98-236.6 147.2-98 236.6-98 173.4 34.8 236.6 98c63.2 63.2 98 147.2 98 236.6s-34.8 173.4-98 236.6c-63.2 63.2-147.2 98-236.6 98z m0-640.3c-81.7 0-158.5 31.8-216.2 89.6-57.8 57.8-89.6 134.5-89.6 216.2 0 81.7 31.8 158.5 89.6 216.2 57.8 57.8 134.5 89.6 216.2 89.6s158.5-31.8 216.2-89.6c57.8-57.8 89.6-134.5 89.6-216.2 0-81.7-31.8-158.5-89.6-216.2-57.7-57.8-134.5-89.6-216.2-89.6z",
    fill: "#154B8B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M652.4 533.1m-230.2 0a230.2 230.2 0 1 0 460.4 0 230.2 230.2 0 1 0-460.4 0Z",
    fill: "#9ED5E4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M227.2 676.2c-11 0-19.9-8.9-19.9-19.9V377.1c0-11 8.9-19.9 19.9-19.9s19.9 8.9 19.9 19.9v279.1c0 11.1-8.9 20-19.9 20z",
    fill: "#10457E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCam2);
export default __webpack_public_path__ + "static/media/cam2.fc5e421d8613760aee811db232f29e43.svg";
export { ForwardRef as ReactComponent };